import React, { useEffect, useRef, useState } from "react";
import SplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";
import { useDispatch, useSelector } from "react-redux";
import { isExcel } from "utils";
import { showInlineAlert } from "slices/app/appSlice";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import Categories from "layout/discovery/folder/categories";
import ContentPanel, {
  getDiscoveryDocItemsArray,
} from "layout/discovery/content/ContentPanel";

const ByTheme = () => {
  const themeRef = useRef();
  const docsRef = useRef();
  const themeListDocRef = useRef();
  const excel = isExcel(
    useSelector((state) => state.discovery.themes[0]?.Documents[0].Name)
  );
  const isEmpty =
    useSelector((state) => state.discovery.themes[0]?.Occurrences) === 0;
  const [categoriesSize, setCategoriesSize] = useState("20%");
  const dispatch = useDispatch();

  const handleDragRelease = () => {
    if (themeListDocRef && themeListDocRef.current) {
      setCategoriesSize(themeListDocRef.current.props.size);
    }
  };

  const themes = useSelector((state) => state.discovery.themes);
  const checkedItems = themes?.filter(
    (theme) => theme.checked && theme.NounPhrase !== undefined
  );
  const selectedDocs = themes?.[0]?.Documents.filter((doc) => !doc.ignored);

  const emptyText = () =>
    excel
      ? "Discovery does not support Excel files."
      : "This file is empty and contains no words. Discovery does not support empty docs.";

  useEffect(() => {
    window.addEventListener("mouseup", handleDragRelease);
    return () => {
      window.removeEventListener("mouseup", handleDragRelease);
    };
  }, []);

  useEffect(() => {
    if (isEmpty || excel) {
      dispatch(
        showInlineAlert({
          variant: alertVariants.warning,
          text: emptyText(),
        })
      );
    }
  }, [dispatch, isEmpty, excel]);

  const styles = {
    background: "transparent",
    width: "1px",
    cursor: "col-resize",
    height: "100%",
    paddingRight: "2px",
    borderRight: "transparent 4px solid",
    borderLeft: "transparent 4px solid",
    margin: "0 -5px",
    zIndex: "1",
  };

  if (isEmpty || excel) return null;

  return (
    <SplitPane
      className="discovery__document"
      style={{ position: "relative", overflow: "hidden" }}
      split="vertical"
      resizerStyle={styles}
    >
      <Pane
        ref={themeListDocRef}
        minSize="260px"
        initialSize={categoriesSize}
        className="discovery__document-left"
      >
        <Categories
          documentsRef={docsRef}
          categoriesRef={themeRef}
          folderView={false}
        />
      </Pane>
      <Pane minSize="200px" className="discovery__document-right">
        <ContentPanel
          docItemsArray={getDiscoveryDocItemsArray(selectedDocs, checkedItems)}
          docView
        />
      </Pane>
    </SplitPane>
  );
};

export default ByTheme;
